import React, { useRef } from 'react';
import { Container } from '@icecreamsocial/components';

export const PageWrapper = ({ children, ...rest }) => {
	return (
		<Container padding={['md', 'md', 'xlg']} flexGrow="1" {...rest}>
			{children}
		</Container>
	);
};
